import { ITrackProductInfoAppParams } from "@/shared";
import { isInApp } from "./is";
import { openProductDetailInApp } from "./in-app-funs";
import { launchAppProductDetail } from "./in-browser-funs";

export async function jumpProductToApp(
  productHashId: string,
  appParams?: ITrackProductInfoAppParams,
  deepLinkUrl?: string,
  callback?: (url: string) => void
) {
  const inApp = isInApp();
  if (inApp) {
    openProductDetailInApp({ hashId: productHashId, appParams });
  } else {
    launchAppProductDetail(productHashId, appParams, callback, deepLinkUrl);
  }
}
